import { useGetAllAnnouncementsQuery } from '@exam-center/graphql';
import { type GridEventListener, type GridRowParams } from '@shared/components';
import { useDisclosure } from '@shared/hooks';
import { useMemo, useState } from 'react';

import { type Announcement, BaseAnnouncementList } from '../../components';
import { AnnouncementDetailsModal } from '../announcement-details-modal';
import { AnnouncementNoRowsOverlay } from '../announcement-no-rows-overlay';
interface AnnouncementListProps {
  openCreateAnnouncementDialog: () => void;
}
export default function AnnouncementList(props: Readonly<AnnouncementListProps>) {
  const { openCreateAnnouncementDialog } = props;
  const [isOpen, { open: onOpen, close: onClose }] = useDisclosure();
  const [selectedAnnouncement, setSelectedAnnouncement] = useState<{
    title: string;
    link: string;
  } | null>(null);

  const { data: announcementsData } = useGetAllAnnouncementsQuery();

  const rows =
    useMemo(
      () =>
        announcementsData?.ecGetAllAnnouncements.announcements
          .map((announcement) => ({
            id: announcement.id,
            title: announcement.title,
            announceAt: announcement.announcedAt,
          }))
          .sort((a, b) => (b.announceAt?.getTime() ?? 0) - (a.announceAt?.getTime() ?? 0)),
      [announcementsData],
    ) ?? [];

  const handleRowClick: GridEventListener<'rowClick'> = (params: GridRowParams<Announcement>) => {
    const announcement = announcementsData?.ecGetAllAnnouncements.announcements.find(
      (item) => item.id === params.row.id,
    );
    if (announcement) {
      setSelectedAnnouncement({
        title: announcement.title,
        link: announcement.link ?? '',
      });
      onOpen();
    }
  };
  return (
    <>
      <BaseAnnouncementList
        rows={rows}
        hideFooter
        onRowClick={handleRowClick}
        slots={{
          noRowsOverlay: () => (
            <AnnouncementNoRowsOverlay openCreateAnnouncementModal={openCreateAnnouncementDialog} />
          ),
        }}
      />
      <AnnouncementDetailsModal
        announcement={selectedAnnouncement}
        open={isOpen}
        onClose={onClose}
      />
    </>
  );
}
